import Map from './components/Map'
import Like from './components/Like'
import Home from './components/Home'
import Connexion from './components/Connexion'
import Main from './components/Main'

export const routes = [
    { path: "/", component: Main },
    { path: "/home", component: Home, redirection: '/connect'},
    { path: "/profil", component: Home },
    { path: "/like", component: Like },
    { path: "/connect", component: Connexion, connected: '/profile' },
    { path: "/map", component: Map },
];